import { Guide } from '.';
import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type CreateGuideStepOptions = {
   title: string;
   time_estimate?: number;
   lines: {
      text: string;
      bullet_styleid: number;
      level: number;
   }[];
   media:
      | null
      | {
           type: 'IMAGE';
           data: number[];
        }
      | {
           type: 'OBJECT';
           data: number;
        };
};

export async function createGuideStep(
   guideId: number,
   orderby: number,
   step: CreateGuideStepOptions,
   common: CommonRequestOptions = {}
): Promise<Guide> {
   return makeRequest('post', `/guides/${guideId}/steps/`, {
      ...common,
      body: {
         ...step,
         orderby,
      },
   });
}
